import { z } from "zod";
import { createStorageStore } from "../../../utils/createStore.ts";
import { CREATE_TOOLS, EDIT_TOOLS } from "../../Board/constants.ts";

const zDefaultTool = z.object({
  defaultCreateTool: z.enum(CREATE_TOOLS).optional(),
  defaultEditTool: z.enum(EDIT_TOOLS).optional(),
});

export type DefaultTool = z.infer<typeof zDefaultTool>;

export const defaultToolStore = createStorageStore(
  localStorage,
  "defaultTool-v1",
  zDefaultTool,
  { defaultCreateTool: undefined, defaultEditTool: undefined },
  ({ set }) => ({
    setTool: (tool: Partial<DefaultTool>) => set(tool),
    clearTool: () =>
      set({ defaultCreateTool: undefined, defaultEditTool: undefined }),
  }),
);
